import { render, staticRenderFns } from "./SignUpCompany.vue?vue&type=template&id=446115aa&"
import script from "./SignUpCompany.vue?vue&type=script&lang=js&"
export * from "./SignUpCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports